import React from 'react';
export function HeroSection() {
  return <section className="px-4 mb-12" data-id="element-103">
      <h2 className="font-handwriting text-4xl md:text-5xl font-bold text-forest leading-tight mb-4 text-center" data-id="element-104">
        "Tony hatte tagelang keinen Stuhlgang – und sein Bauch war extrem
        aufgebläht"
      </h2>
      <p className="font-serif text-lg text-text/80 text-center mb-8 leading-relaxed px-2" data-id="element-105">
        Wie ich herausfand, dass gutes Futter allein nicht reicht – und was
        seine Verdauung wirklich beruhigt hat.
      </p>
      <div className="relative rounded-2xl overflow-hidden shadow-diary aspect-[4/3] md:aspect-[16/10]" data-id="element-106">
        <img src="https://images.unsplash.com/photo-1543466835-00a7907e9de1?q=80&w=1000&auto=format&fit=crop" alt="Ein süßer, aber dünner Hund schaut erwartungsvoll nach oben" className="w-full h-full object-cover" data-id="element-107" />
        <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent" data-id="element-108"></div>
      </div>
    </section>;
}